import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';
import { fetchFlowchartVersions } from '../../request/flowchart/flowchart.api';
import { sortProcessesForEndToEnd } from './cycleEndToEndProcesses';
import { pickCombinedFlowchartVersion } from './pickCombinedFlowchartVersion';

export async function fetchCombinedFlowchartPages(cycleId, processes) {
  const ordered = sortProcessesForEndToEnd(processes).filter((process) => Boolean(process?.has_flowchart));
  const pages = [];

  for (const process of ordered) {
    const processId = String(process?.process_id ?? process?.id ?? '').trim();
    if (!processId) continue;

    const versions = await fetchFlowchartVersions(cycleId, processId);
    const version = pickCombinedFlowchartVersion(versions);
    if (!version || version.value == null) continue;

    const response = await axiosInstance.get(API_ENDPOINTS.getFlowchart(cycleId, processId), {
      params: { versionNumber: version.value },
    });
    if (!response?.data?.success || !response.data?.flowchartData) continue;

    pages.push({
      process,
      processId,
      version,
      flowchartData: response.data.flowchartData,
      flowchartVersionId: response.data.flowchartVersionId || version.flowchartVersionId,
      versionNumber: response.data.versionNumber ?? version.value,
      versionStatus: response.data.versionStatus || version.status,
      isActive: response.data.isActive === true || version.isActive === true,
    });
  }

  return pages;
}
